import React, { Component } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { Timer } from './Timer';

export class ForthModel extends Component {
    displayName = ForthModel.name

    constructor(props) {
        super(props);
        this.state = {
            currentCount: 0,
            name: "",
            core: "",
            category: "Здоровье и фитнес",          
            topn: 100,
            result: "",
            loading: false,
            button: "Результаты",
            minutes: 0,
            seconds: 0,
            serviceType: 1
        };
        this.incrementCounter = this.incrementCounter.bind(this);
        this.setName = this.setName.bind(this);
        this.setCore = this.setCore.bind(this);
        this.setCategory = this.setCategory.bind(this);
        this.setTopn = this.setTopn.bind(this);
        this.getResult = this.getResult.bind(this);
        this.start = this.start.bind(this);
        this.setDescriptionModel = this.setDescriptionModel.bind(this);
        this.setCoreModel = this.setCoreModel.bind(this);
    }

    start() {
           this.myInterval = setInterval(() => {
            const { seconds, minutes } = this.state

            //if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds + 1
                }))
            //}
            if (seconds === 59) {
                //if (minutes === 0) {
                //    clearInterval(this.myInterval)
                //} else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes + 1,
                        seconds: 0
                    }))
                //}
            }
        }, 1000)
    }
    incrementCounter() {
        this.setState({
            currentCount: this.state.currentCount + 1
        });
    }
    setName(str) {
        this.setState({ name: str });
    }
    setCore(str) {
        this.setState({ core: str });
    }
    setCategory(str) {
        this.setState({ category: str });
    }
    setTopn(str) {
        this.setState({ topn: str });
    }
    setDescriptionModel(e) {
        this.setState({ serviceType: 0 });
    }
    setCoreModel(e) {
        this.setState({ serviceType: 1});
    }

    getResult() {
        this.setState({ loading: true, button: "..Progress", seconds: 0, minutes: 0 });
        this.start();
        fetch('api/model/forth', {
            method: 'post',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                name: this.state.name,
                core: this.state.core,
                category: this.state.category,
                topN: this.state.topn,
                serviceType: this.state.serviceType
            })
        }).then(response => response.json())
            .then(data => {
                this.setState({ result: data.result, loading: false, button: "Результаты" });
                clearInterval(this.myInterval);
            });
    }

    render() {
        const { minutes, seconds } = this.state
        var s = this.state.serviceType;
        return (
            <div className="col-md-11">
                <h1>Сиамская нейронная сеть</h1>
                <h3>Семантические ядра</h3>
                <div className="row form-group">
                    <input name="name" placeholder="Название" className="form-control" type="text" value={this.state.name} onChange={(e) => this.setName(e.target.value)}></input>
                </div>
                <div className="row form-group">
                    <textarea name="name" placeholder="Семантическое ядро, через запятую" rows="10" className="form-control" type="text" value={this.state.core} onChange={(e) => this.setCore(e.target.value)}></textarea>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <h4>Категория:</h4>
                    </div>
                    <div className="col-md-1">
                        <DropdownButton title={this.state.category}>
                            <MenuItem onClick={(e) => this.setCategory("Wear OS by Google")}>Wear OS by Google</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Автомобили и транспорт")}>Автомобили и транспорт</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Аркады")}>Аркады</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Аудио и музыка")}>Аудио и музыка</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Видеоплееры и редакторы")}>Видеоплееры и редакторы</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Викторины")}>Викторины</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Головоломки")}>Головоломки</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Гонки")}>Гонки</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Головоломки")}>Головоломки</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Для всей семьи")}>Для всей семьи</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Еда и напитки")}>Еда и напитки</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Жилье и дом")}>Еда и напитки</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Здоровье и фитнес")}>Здоровье и фитнес</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Знакомства")}>Знакомства</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Игры")}>Игры</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Игры для ума")}>Игры для ума</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Инструменты")}>Инструменты</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Искусство и дизайн")}>Искусство и дизайн</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Казуальные")}>Казуальные</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Казино")}>Казино</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Карточные")}>Карточные</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Красота")}>Красота</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Комиксы")}>Комиксы</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Карты и навигация")}>Карты и навигация</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Книги и справочники")}>Книги и справочники</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Музыка")}>Музыка</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Музыка и аудио")}>Музыка и аудио</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Музыка и видео")}>Музыка и видео</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Материнство и детство")}>Материнство и детство</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Медицина")}>Медицина</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Мероприятия")}>Мероприятия</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Музыкальные игры")}>Музыкальные игры</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Настольные игры")}>Настольные игры</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Новости и журналы")}>Новости и журналы</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Образование")}>Образование</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Обучающие")}>Обучающие</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Обучающие игры")}>Обучающие игры</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Персонализация")}>Персонализация</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Погода")}>Погода</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Покупки")}>Покупки</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Приключения")}>Приключения</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Продуктивность")}>Продуктивность</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Путешествия")}>Путешествия</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Развлечения")}>Развлечения</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Разное")}>Разное</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Ролевые")}>Ролевые</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Связь")}>Связь</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Симуляторы")}>Симуляторы</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Словесные")}>Словесные</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Социальные")}>Социальные</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Спортивные игры")}>Спортивные игры</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Стратегии")}>Стратегии</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Стиль жизни")}>Стиль жизни</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Спорт")}>Спорт</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Словесные игры")}>Словесные игры</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Семейные")}>Семейные</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Словесные")}>Словесные</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Спортивные")}>Спортивные</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Творчество")}>Творчество</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Финансы")}>Финансы</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Фотография")}>Фотография</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Экшен")}>Экшен</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Экшн")}>Экшн</MenuItem>
                        </DropdownButton>
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <h4>TopN:</h4>
                    </div>
                    <div className="col-md-2">
                        <input name="name" placeholder="от 1 до 500" className="form-control" type="text" value={this.state.topn} onChange={(e) => this.setTopn(e.target.value)}></input>

                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-md-2"> <button className="button" onClick={this.getResult} disabled={this.state.loading}>{this.state.button}</button> </div>
                    <div className="col-md-6">  </div>
                    <div className="col-md-4"> 
                        {<h4>Прошло времени: {minutes}:{seconds < 10 ? `0${seconds}` : seconds}</h4>}
                    </div>
                </div>
                <br></br>
                <div className="row form-group" style={{ marginTop: '5px' }}>
                    <textarea name="name" placeholder="Результаты" rows="10" className="form-control" type="text" value={this.state.result} ></textarea>
                </div>
            
             
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ForthModel.js